<template>
  <!-- 会员等级 -->
  <a-layout-content>
    <div v-if="role241">
      <a-button type="primary" @click="add()">添加等级</a-button>
    </div>
    <br />
    <a-table
      size="middle"
      :columns="columns"
      row-key="ID"
      :data-source="data"
      :pagination="false"
      :scroll="{ y: 800 }"
      bordered
    >
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="edit(record)" v-if="role241">
          <a-icon type="edit" style="font-size: 22px"></a-icon>
        </a>
        &nbsp;
        <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)" v-if="role243">
          <a href="javascript:;">
            <a-icon type="delete" style="font-size: 22px"></a-icon>
          </a>
        </a-popconfirm>
      </template>
    </a-table>

    <!-- 对话框 ------------------------------------->
    <a-modal
      v-model="visible"
      :title="modaltype === 0 ? '新增等级' : '编辑等级'"
      @ok="handleOk"
    >
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="等级名称" ref="Vip" prop="Vip">
          <a-input v-model.number="form.Vip" placeholder="等级名称" />
        </a-form-model-item>
        <a-form-model-item label="累积存款" ref="Upamt" prop="Upamt">
          <a-input v-model.number="form.Upamt" placeholder="晋级标准(累积存款)" />
        </a-form-model-item>
        <a-form-model-item label="普级礼金" ref="Upbonus" prop="Upbonus">
          <a-input
            v-model.number="form.Upbonus"
            placeholder="向上普级获得的礼金奖励"
          />
        </a-form-model-item>
        <a-form-model-item label="每周存款量" ref="Weektotal" prop="Weektotal">
          <a-input
            v-model.number="form.Weektotal"
            placeholder="每周存款量，当每周存款额大于这个值，才能发放周俸禄"
          />
        </a-form-model-item>
        <a-form-model-item label="每周俸禄" ref="Weekbonus" prop="Weekbonus">
          <a-input v-model.number="form.Weekbonus" placeholder="每周可领取俸禄" />
        </a-form-model-item>
        <a-form-model-item label="每月存款量"  ref="Monthtotal" prop="Monthtotal">
          <a-input
            v-model.number="form.Monthtotal"
            placeholder="每月存款量，当月存款额大于这个值，才能发放月俸禄"
          />
        </a-form-model-item>
        <a-form-model-item label="每月俸禄"  ref="Monthbonus" prop="Monthbonus">
          <a-input v-model.number="form.Monthbonus" placeholder="每月可领取俸禄" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
import { isNumber } from "../../js/textverify";

export default {
  data() {
    return {
      /*** 权限
        241	会员等级新增/编辑
        242	会员等级查询
        243	会员等级删除
       */
      role36:false,
      role37:false,
      role38:false,
      visible: false,
      modaltype: 0,
      data: [],
      columns: [
        {
          title: "编号",
          dataIndex: "ID",
          align: "center",
        },
        {
          title: "UVIP",
          dataIndex: "Vip",
          align: "center",
        },
        {
          title: "晋级标准(累积存款)",
          dataIndex: "Upamt",
          align: "center",
          width: "200px"
        },
        {
          title: "普级礼金",
          dataIndex: "Upbonus",
          align: "center",
        },
        {
          title: "每周存款量",
          dataIndex: "Weektotal",
          align: "center",
        },
        {
          title: "每周俸禄",
          dataIndex: "Weekbonus",
          align: "center",
        },
        {
          title: "每月存款量",
          dataIndex: "Monthtotal",
          align: "center",
        },
        {
          title: "每月俸禄",
          dataIndex: "Monthbonus",
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "operation",
          align: "center",
          scopedSlots: { customRender: "operation" },
        },
      ],
      form: {},
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      rules:{
        Vip: [
          { required: true, message: '请输入等级名称', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
        Upamt: [
          { required: true, message: '请输入累积存款', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
        Upbonus: [
          { required: true, message: '请输入普级礼金', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
        Weektotal: [
          { required: true, message: '请输入每周存款量', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
        Weekbonus: [
          { required: true, message: '请输入每周俸禄', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
        Monthtotal: [
          { required: true, message: '请输入每月存款量', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
        Monthbonus: [
          { required: true, message: '请输入每月俸禄', trigger: 'blur' },
          { validator: isNumber, trigger: 'change' },
        ],
      }
    };
  },
  methods: {
    onDelete(val) {
      this.axios.post("/rank/deleteuserrank", {id:val.ID}).then((res) => {
        if (res.data) {
          this.$message.success("删除成功");
          this.qryListAPI();
        }
      });
    },
    add() {
      this.modaltype = 0;
      this.form = {};
      this.form.ID = 0;
      this.form.Type = 3;
      this.visible = true;
    },
    edit(val) {
      this.modaltype = 1;
      this.form = val;
      this.visible = true;
    },
    //对话框确认按钮
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.axios.post("/rank/setuserrank", this.form).then((res) => {
            if(res.data){
              const mes = this.modaltype === 0 ? "添加成功" : "编辑成功";
              this.$message.success(mes);
              this.qryListAPI();
            }
          });
        } 
      });
    },
    // 查询API
    qryListAPI() {
      this.axios.post("/rank/getuserrank", {Type:3}).then((res) => {
        if (res.data) {
          this.data = res.data;
        }
      });
    },
  },
  //首次加载
  created() {
    this.qryListAPI();
    //获取权限
    const array = JSON.parse(sessionStorage.RoleID);
    const roleID = [241,242,243];
    var isRole = roleID.filter(function(item){
      return array.indexOf(item) != -1
    });
    //功能权限获取
    isRole.forEach(element => {
      this["role" + element] = true;
    });
  },
};
</script>


// WEBPACK FOOTER //
// src/components/usdtleaderboard/viprank.vue